import { Box, Typography } from "@mui/material";
import Player from 'lottie-react';
import emptyGhost from '../files/json/empty-ghost.json';
import { useSettings } from '../providers/settings-provider';

interface TablePlaceholderProps {
    title?: string;
    message?: string;
    latestTransaction?: Date | null;
    earliestTransaction?: Date | null;
    totalCount?: number;
}

const TablePlaceholder: React.FC<TablePlaceholderProps> = ({ title, message, latestTransaction, earliestTransaction, totalCount }) => {
    const { formatDate } = useSettings();
    return (
        <Box 
            sx={{ 
                p: 4, 
                color: 'red', 
                textAlign: 'center', 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                width: '100%',
                height: '100%',
                boxSizing: 'border-box',
            }}
        >
            <Player
                autoplay
                loop
                animationData={emptyGhost}
                style={{ height: 120, width: 120 }}
            />
            <Typography color="red" fontSize={18}>
                {title || "No Data Available"}
            </Typography>
            <Typography variant="body2" fontSize={14} fontStyle="italic" color="text.secondary">
                {message || "Try adjusting your filters or refresh the page."}
            </Typography>
            {((totalCount !== undefined && totalCount > 0) || (latestTransaction || earliestTransaction)) && (
                <Box 
                    sx={{ 
                        mt: 3, 
                        p: 2, 
                        backgroundColor: 'var(--color-container-background)',
                        border: '1px solid #e0e0e0',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 400
                    }}
                >
                    {totalCount !== undefined && totalCount > 0 && (
                        <Typography variant="body2" fontSize={14} fontWeight={600} color="primary" sx={{ mb: 1.5 }}>
                            📊 Total Transactions: <strong>{totalCount}</strong>
                        </Typography>
                    )}
                    {(latestTransaction || earliestTransaction) && (
                        <Box>
                            <Typography variant="caption" fontSize={11} color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                Data Range Available
                            </Typography>
                            {latestTransaction && earliestTransaction ? (
                                <Typography variant="body2" fontSize={13} color="text.primary">
                                    📅 {formatDate(earliestTransaction)} → {formatDate(latestTransaction)}
                                </Typography>
                            ) : latestTransaction ? (
                                <Typography variant="body2" fontSize={13} color="text.primary">
                                    📅 Latest: {formatDate(latestTransaction)}
                                </Typography>
                            ) : earliestTransaction ? (
                                <Typography variant="body2" fontSize={13} color="text.primary">
                                    📅 Earliest: {formatDate(earliestTransaction)}
                                </Typography>
                            ) : null}
                        </Box>
                    )}
                </Box>
            )}
        </Box> 
    );
};

export default TablePlaceholder;
